import qs from 'qs';

export const isPreview = search => {
	const parsedQuery = qs.parse(search || '', { ignoreQueryPrefix: true });
	return !!parsedQuery.preview;
};
